<template>
  <fragment>
    <div
        class="new-update-section"
        v-show="
        contests_updated &&
        !no_matches_active &&
        !checkIfTourIsActive() &&
        parentRoute === CFG_MODULES.GAME_PLAN.route
      "
    >
      <button
          type="submit"
          v-bind:class="['btn btn-update', contests_updated ? 'active' : '']"
          @click.stop="loadUpdatedContestList"
      >
        {{ translations.contest_list_updated }}
      </button>
    </div>
    <div class="waf-head" v-show="!no_matches_active">
      <div class="head-wrap">
        <div v-swiper:category_slider="options" ref="category_slider">
          <div class="swiper-wrapper">
            <a
                :href="getFirstNodeHref(cat.category_id)"
                class="swiper-slide custom-slide"
                v-for="cat in in_match_categories"
                v-bind:key="cat.category_id"
                v-bind:class="[{
                  'active': cat.category_id === (current_match && current_match.category_id)
                }]"
            >
              {{ cat.category_name }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </fragment>
</template>
<script>
import {
  getMatch,
  updateStorage,
  formatFullUrl
} from "../../../assets/js/common";
import {Fragment} from "vue-fragment";
import {CFG_MODULES} from "../../../assets/js/config";

export default {
  data() {
    return {
      showTutorial: false,
      tour: null,
      options: {
        slidesPerView: "auto",
        spaceBetween: 20,
      },
      CFG_MODULES,
    };
  },
  components: {
    Fragment,
  },
  props: [
    "loadUpdatedContestList",
    "parentRoute",
    "loaded_module",
    "eventChangeHandler"
  ],
  computed: {
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    no_matches_active() {
      return this.$store.state.match_detail_store.no_matches_active;
    },
    in_match_categories() {
      let allCategories = this.$store.state.match_detail_store.in_match_categories;
      let categoriesBySport = allCategories.filter(c => c.sport_id === this.$store.state.match_detail_store.current_sport);
      categoriesBySport = categoriesBySport.filter(c => this.getFirstMatch(c.category_id)); // removing categories which don't have url for page
      return categoriesBySport;
    },
    slug: {
      get: function () {
        return this.$store.state.match_detail_store.slug;
      },
      set: function (new_slug) {
        this.$store.state.match_detail_store.slug = new_slug;
      },
    },
    current_match() {
      return getMatch(this.match_data, "slug", this.slug);
    },
    contests_updated() {
      if (this.loaded_module === CFG_MODULES.GAME_PLAN.name && this.$store.state[CFG_MODULES.GAME_PLAN.name]){
        return this.$store.state[this.loaded_module].contests_updated;
      }
      return false;
    },
    translations() {
      return this.$store.state.translations;
    },
    current_category: {
      get() {
        return this.$store.state.match_detail_store.current_category;
      },
      set(val) {
        this.$store.state.match_detail_store.current_category = val;
      },
    },
    isTourActive: {
      get: function () {
        return this.$store.state.match_detail_store.isTourActive;
      },
      set: function (val) {
        this.$store.state.match_detail_store.isTourActive = val;
      },
    },
  },
  methods: {
    getFirstMatch(category_id) {
      if (this.match_data && this.match_data[category_id].length) {
        let first_node = null;
        if (this.parentRoute === CFG_MODULES.LINEUP.route) {
          first_node = this.match_data[category_id].find((m) => m.show_lineup);
        } else {
          first_node = this.match_data[category_id].find((m) => true);
        }

        return first_node;
      } else {
        return null;
      }
    },
    getFirstNodeHref(category_id) {
      if (this.match_data && this.match_data[category_id].length) {
        let first_node = this.getFirstMatch(category_id);
        if(first_node) {
          // if(first_node.noLink) {
          //   return null;
          // } else {
            let matchUrl = formatFullUrl(first_node, this.parentRoute);
            return matchUrl;
          // }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
    checkIfTourIsActive() {
      return this.$store.state.match_detail_store.isTourActive;
    },
    getStepsArr() {
      let tourTrans = this.translations.tour.lineup;
      return [
        {
          title: tourTrans["tour_step_1_title"],
          text: tourTrans["tour_step_1_text"],
          attachTo: {
            element: ".section1",
            on: "top",
          },
          buttons: [
            {
              action() {
                return this.next();
              },
              text: "NEXT",
            },
          ],
          id: "creating-1",
        },
        {
          title: tourTrans["tour_step_2_title"],
          text: tourTrans["tour_step_2_text"],
          attachTo: {
            element: `.section2`,
            on: "bottom",
          },
          buttons: [
            {
              action() {
                return this.back();
              },
              classes: "shepherd-button-secondary",
              text: "BACK",
            },
            {
              action() {
                return this.next();
              },
              text: "NEXT",
            },
          ],
          id: "creating-2",
        },
        {
          title: tourTrans["tour_step_3_title"],
          text: tourTrans["tour_step_3_text"],
          attachTo: {
            element: ".contest-item:nth-child(1)",
            on: "bottom",
          },
          buttons: [
            {
              action() {
                updateStorage("show_tour", "done");
                return this.complete();
              },
              classes: "shepherd-got-it-btn",
              text: "PROCEED",
            },
          ],
          id: "creating-3",
        },
      ];
    },
  },
};
</script>
